import { render, staticRenderFns } from "./withdrawal-card.vue?vue&type=template&id=e48e7d32&scoped=true&"
import script from "./withdrawal-card.vue?vue&type=script&lang=js&"
export * from "./withdrawal-card.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-card.vue?vue&type=style&index=0&id=e48e7d32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48e7d32",
  null
  
)

export default component.exports